// MakeService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  ChangeStatusMakeResponse,
  DeleteMakeResponse,
  GetMakeByIdResponse,
  GetMakeDropdownResponse,
  GetMakeResponse,
  MakeRequest,
  MakeResponse,
} from './interface';

export class MakeProfile extends BaseService {
  async createMake(req: MakeRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.post<MakeResponse, FormData>(`${this.apiUrl}/api/makes`, formData, { headers });
  }

  async getMake(params: PaginationParams) {
    return this.get<GetMakeResponse>(`${this.apiUrl}/api/makes/paged`, params);
  }

  async getMakeDropdown(params: PaginationParams) {
    return this.get<GetMakeDropdownResponse>(`${this.apiUrl}/api/makes/get`, params);
  }

  async updateMake(req: MakeRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.put<MakeResponse, FormData>(`${this.apiUrl}/api/makes/update`, formData, { headers });
  }

  async deleteMake(id: number) {
    return this.delete<DeleteMakeResponse>(`${this.apiUrl}/api/makes/${id}`);
  }

  async changeStatusMake(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusMakeResponse, ChangeStatusRequest>(`${this.apiUrl}/api/makes/${active}/${id}`, req);
  }

  async getMakeByID(id: number) {
    return this.get<GetMakeByIdResponse>(`${this.apiUrl}/api/makes/${id}`);
  }
}
